<template>
  <div id="honor_tab"
       class="main-tab main-tab-o">
    <div class="dv-content-honor">
      <img src="../assets/images/icon_ho_bg.png"
           class="img-ho-bg">
      <div class="dv-content-ho-s">
        <div class="tv-title">获此殊荣 备感荣幸</div>
        <div class="dv-content-items-ho">
          <img src="../assets/images/icon_ho_bg_bottom.png"
               class="img-ho-bg-b">
          <div class="dv-item-photo-ho"
               v-for="(item,index) in honorlists"
               v-bind:key="index">
            <div class="dv-photo-bg-s">
              <el-image :src="item.fileUrl"
                        class="img-photo-ho"
                        fill="contain"></el-image>
            </div>
            <span class="tv-de-name-ho">{{ item.title }}</span>
          </div>

          <div class="dv-fenye">
            <el-pagination background
                           layout="prev, pager, next"
                           prev-text="上一页"
                           next-text="下一页"
                           :page-size='showCount'
                           :total="totalResult"
                           @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import api from '../api/api'
export default {

  data () {
    return {
      honorlists: [],//荣誉资质列表
      showCount: 20,
      totalResult: 0,
      currentPage: 1,
    }
  },
  created () {
    this.honorlist();
  },
  methods: {
    //分页切换
    handleCurrentChange (e) {
      console.log(e)
      this.currentPage = e
      this.honorlist()

    },

    //荣誉资质列表
    honorlist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: this.currentPage,
        showCount: this.showCount,

      }
      api.honorlist(parm).then((res) => {
        this.honorlists = res.data.list
        this.totalResult = res.data.page.totalResult

      })
    },
  }

}
</script>

<style>
.dv-content-honor {
  width: 100%;
  height: fit-content;
  display: flex;
  position: relative;
  flex-direction: column;
}
.img-ho-bg {
  position: absolute;
  /* top: 40px; */
  left: 0;
  width: 100%;
}
.dv-content-ho-s {
  width: calc(100% - 600px);
  height: fit-content;
  margin-left: 300px;
  margin-top: 40px;
  height: fit-content;
  display: flex;
  flex-direction: column;
}
.tv-title {
  font-size: 28px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  margin-top: 100px;
  color: #ffffff;
}
.dv-content-items-ho {
  width: 100%;
  background: #fcf6f1;
  height: fit-content;
  margin-top: 50px;
  display: flex;
  flex-direction: row;
  position: relative;
  min-height: 800px;
  flex-flow: row wrap;
  margin-bottom: 20px;
  flex-wrap: wrap;
  flex-shrink: 0;
  padding-top: 200px;
}
.img-ho-bg-b {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}
.dv-item-photo-ho {
  width: calc(25% - 25px);
  margin-left: 20px;
  height: fit-content;
  margin-bottom: 40px;
  display: flex;
  margin-top: 20px;
  flex-direction: column;
}
.dv-photo-bg-s {
  width: 100%;
  height: fit-content;
  padding: 20px;
  background: url("../assets/images/icon_ho_di.png");
}
.img-photo-ho {
  width: 100%;
  /* height: 400px; */
}
.tv-de-name-ho {
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #333333;
  margin-top: 10px;
}
.dv-fenye {
  margin-top: 20px;
  width: 100%;
  height: 60px;
}
</style>